export default __webpack_public_path__ + "static/media/empty-order.fc0d4e29.svg";